export default __webpack_public_path__ + "static/media/api.c5d37ae9.pdf";